/* RESPONSIBLE TEAM: team-ai-agent */
import Model, { attr } from '@ember-data/model';

export default class Settings extends Model {
  @attr('string') declare aiToneOfVoice: string;
  @attr('string') declare aiAnswerLength: string;
  @attr('string') declare aiLanguageStyle: string;
}
